import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';
import { of, tap, catchError, throwError } from 'rxjs';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

const iconCache = {};
const fetchIcon = (icon, http) => {
    if (iconCache[icon]) {
        return of(iconCache[icon]);
    }
    return http.get(`/assets/icons/${icon}.svg`, {
        responseType: 'text'
    }).pipe(tap(iconContent => {
        iconCache[icon] = iconContent;
    }), catchError((err) => {
        if (err.status === 404 && icon !== 'question_mark') {
            return fetchIcon('question_mark', http);
        }
        return throwError(() => err);
    }));
};
class SvgIconDirective {
    constructor(el, http) {
        this.el = el;
        this.http = http;
        this._smSvgIcon = '';
    }
    set smSvgIcon(icon) {
        if (icon !== this._smSvgIcon) {
            this._smSvgIcon = icon;
            fetchIcon(icon, this.http).subscribe((x) => {
                this.el.nativeElement.innerHTML = x;
                this.el.nativeElement.children[0].style.display = 'block';
            });
        }
    }
}
SvgIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SvgIconDirective, deps: [{ token: i0.ElementRef }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Directive });
SvgIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.6", type: SvgIconDirective, selector: "[smSvgIcon]", inputs: { smSvgIcon: "smSvgIcon" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SvgIconDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[smSvgIcon]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.HttpClient }]; }, propDecorators: { smSvgIcon: [{
                type: Input
            }] } });

class SvgIconModule {
}
SvgIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SvgIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SvgIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: SvgIconModule, declarations: [SvgIconDirective], imports: [CommonModule,
        HttpClientModule], exports: [SvgIconDirective] });
SvgIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SvgIconModule, imports: [CommonModule,
        HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SvgIconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SvgIconDirective
                    ],
                    imports: [
                        CommonModule,
                        HttpClientModule,
                    ],
                    exports: [SvgIconDirective],
                    providers: [],
                    bootstrap: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SvgIconDirective, SvgIconModule };
